import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Saurabh Saxena </span>
            from <span className="purple"> Uttar Pradesh, India.</span>
            <br />
            I am currently pursuing B.Tech in Computer Science & Engineering 
            <br />
            <br />
             I am <span className="purple">GATE CSE'25</span> qualified.
            <br />
            <span className="purple">Future Group of Institue Bareilly, </span>
            Uttar Pradesh, India.
            <br />
            <br />
            <span className="purple">
              Dr. APJ Abdul Kalam University Lucknow, Uttar Pradesh.{" "}
            </span>
            <br />
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Watching historical dramas
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Saurabh Saxena</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
